import { usePageTitle } from "@/hooks/usePageTitle";

export default function ImpressumPage() {
  usePageTitle("Impressum");
  return (
    <div className="py-12 md:py-24 px-4 md:px-8" data-testid="impressum-page">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight mb-10" style={{ fontFamily: 'Oswald' }}>
          Impre<span style={{ color: '#fbbf24' }}>ssum</span>
        </h1>

        <div className="space-y-10">
          {/* Kontakt-Box prominent */}
          <div className="p-6 bg-card border border-white/10" data-testid="impressum-contact">
            <h2 className="text-lg font-bold uppercase tracking-tight mb-4" style={{ fontFamily: 'Oswald', color: '#fbbf24' }}>Kontakt</h2>
            <p className="font-semibold text-base mb-1">Simply N Gastro und Handels GmbH</p>
            <p className="text-sm text-muted-foreground">Stelzhamerstraße 9, 4600 Wels</p>
            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <a href="tel:+437242216406" className="inline-flex items-center gap-2 px-4 py-2.5 bg-primary/10 border border-primary/20 text-sm font-medium hover:bg-primary/20 transition-colors" data-testid="impressum-phone">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                +43 (0)7242 216406
              </a>
              <a href="mailto:office@ninersbillard.com" className="inline-flex items-center gap-2 px-4 py-2.5 bg-primary/10 border border-primary/20 text-sm font-medium hover:bg-primary/20 transition-colors" data-testid="impressum-email">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                office@ninersbillard.com
              </a>
            </div>
          </div>

          <Section title="Firmendaten laut Gewerbedatenbank">
            <Row label="Firmenname" value="Simply N Gastro und Handels GmbH" />
            <Row label="Firmenbuchnummer" value="FN 626165 g" />
            <Row label="Firmengericht" value="Landesgericht Wels" />
          </Section>

          <Section title="Zusätzliche erweiterte Firmendaten">
            <Row label="Geschäftsbezeichnung" value="Gastronomie und Handel mit Waren aller Art" />
            <Row label="Adresse" value="Stelzhamerstraße 9, 4600 Wels" />
            <Row label="Rechtsform" value="Gesellschaft mit beschränkter Haftung" />
            <Row label="Geschäftsführung" value="Mag. Bettina Blacher" />
            <Row label="Telefon" value="+43 (0)7242 216406" link="tel:+437242216406" />
            <Row label="Web" value="www.ninersbillard.com" link="https://www.ninersbillard.com" />
            <Row label="E-Mail" value="office@ninersbillard.com" link="mailto:office@ninersbillard.com" />
          </Section>

          <Section title="Rechtliche Informationen">
            <Row label="Gewerbebehörde" value="Magistrat der Stadt Wels" />
            <Row label="Anwendbare Rechtsvorschriften" value={<>Gewerbeordnung siehe <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline underline-offset-2">www.ris.bka.gv.at</a></>} />
            <Row label="Weitere Aufsichtsbehörde (gem. ECG)" value="Mitglied der Wirtschaftskammer OÖ" />
          </Section>

          <Section title="Kennnummern">
            <Row label="UID-Nummer" value="ATU80703623" />
          </Section>

          <Section title="Offenlegung nach Mediengesetz">
            <Row label="Medieninhaber" value="Simply N Gastro und Handels GmbH" />
            <Row label="Firmensitz" value="4600 Wels" />
            <Row label="Unternehmensgegenstand" value="Gastronomie und Handel mit Waren aller Art" />
          </Section>

          <Section title="Berechtigungen">
            <Berechtigung taetigkeit="Gastgewerbe in der Betriebsart Cafe" gisa="37103767" />
            <Berechtigung taetigkeit="Halten von Spielen" gisa="37103866" />
            <Berechtigung taetigkeit="Handelsgewerbe mit Ausnahme der reglementierten Handelsgewerbe" gisa="37103842" />
          </Section>

          <Section title="Verbraucherstreitbeilegung">
            <p className="text-sm text-muted-foreground">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              Plattform der EU-Kommission zur Online-Streitbeilegung:{' '}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer"
                className="text-primary hover:underline underline-offset-2">
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
          </Section>

          <Section title="Haftungshinweis">
            <p className="text-sm text-muted-foreground">
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
              externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
              verantwortlich.
            </p>
          </Section>

          <Section title="Inhalte">
            <p className="text-sm text-muted-foreground">
              Für den Inhalt verantwortlich ist die Simply N Gastro und Handels GmbH
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-base md:text-lg font-bold uppercase tracking-tight mb-4 pb-2 border-b border-white/10" style={{ fontFamily: 'Oswald', color: '#fbbf24' }}>
        {title}
      </h2>
      <div>{children}</div>
    </div>
  );
}

function Row({ label, value, link }) {
  return (
    <div className="flex flex-col sm:flex-row sm:gap-2 py-1.5 text-sm">
      <span className="font-semibold sm:min-w-[260px] shrink-0">{label}:</span>
      {link ? (
        <a href={link} className="text-primary hover:underline underline-offset-2">{value}</a>
      ) : (
        <span className="text-muted-foreground">{value}</span>
      )}
    </div>
  );
}

function Berechtigung({ taetigkeit, gisa }) {
  return (
    <div className="py-2 text-sm">
      <p className="font-semibold">{taetigkeit}</p>
      <p className="text-muted-foreground">GISA-Zahl: {gisa}</p>
    </div>
  );
}
